"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles = (theme) => (0, styles_1.createStyles)({
    dialogTitle: Object.assign(Object.assign({}, theme.typography.h5), { marginBottom: theme.spacing(1.5) }),
    content: {
        width: '100%',
        maxWidth: 408
    },
    dialogContent: {
        padding: 0
    },
    dialogBackground: {
        padding: theme.spacing(3)
    },
    cardBackground: {
        width: '100%',
        boxSizing: 'border-box',
        borderRadius: 0,
        padding: theme.spacing(5),
        paddingTop: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
    },
    redeemSuccessModalActions: {
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        padding: theme.spacing(3),
        paddingTop: theme.spacing(1.5)
    },
    redeemSuccessText: {
        marginBottom: theme.spacing(2)
    },
    downloadContainer: {
        gap: theme.spacing(1),
        marginLeft: 0,
        marginRight: 0
    },
    text: {
        marginTop: theme.spacing(2),
        wordBreak: 'break-all'
    },
    title: {
        textTransform: 'uppercase'
    },
    image: {
        marginTop: theme.spacing(3.5)
    },
    dialogTitleWrapper: {
        padding: theme.spacing(3)
    }
});
exports.default = styles;
//# sourceMappingURL=RedeemCouponModalConfirmationStyle.js.map